import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './PlayerPlayToggle.css'

export default class PlayerPlayToggle extends React.PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			prepareTransition: true,
			isPaused: true,
			animate: false
		}
		this.onAnimationEnd = this.onAnimationEnd.bind(this)
	}

	componentWillReceiveProps( props ) {

		const { isPlaying } = props
		if ( isPlaying !== this.props.isPlaying) {
			this.setState({
				isPaused: false,
				showPauseButton: !isPlaying,
				prepareTransition: true,
				animate: true
			}, () => {
				// const forceReflow = this.ref.offsetTop
				this.setState({
					cancelTransition: false,
					prepareTransition: false,
				})
			})
		}

	}

	onAnimationEnd() {

		if (this.state.cancelTransition) { return }

		if ( this.props.isPlaying ){
			this.setState({
				showPauseButton: true,
				prepareTransition: true,
				animate: false,
			})
		} else {
			//const forceReflow = this.ref.offsetTop
				this.setState({
					showPauseButton: false,
					prepareTransition: true,
					cancelTransition: true,
					isPaused: true,
					animate: true
				}, () => {
					// const forceReflow = this.ref.offsetTop
					this.setState({
						isPaused: true,
						prepareTransition: false,
					})
				})
		}

	}

	render() {

		const className = classnames('player__play-toggle', {
			'initiated': this.props.isInitiated,
			'show-pause': this.state.showPauseButton,
			'show-play': !this.state.showPauseButton,
			'paused': this.state.isPaused,
			'bounce': !this.state.isPaused && this.state.animate && !this.state.prepareTransition,
		})

		return (
			<div
				ref={ ref => this.ref = ref }
				className={ className }
				onClick={ this.props.onClick }
				onAnimationEnd={ this.onAnimationEnd }
			/>
		)
	}
}

PlayerPlayToggle.propTypes = {
	onClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/player/controls/play/PlayerPlayToggle.jsx